<template>
  <section class="auth-summer-page bg-no-repeat bg-center bg-cover w-full min-h-[100vh]">
    <div class="auth-summer-wrap w-full relative mx-auto flex flex-col justify-between items-center max-w-[1400px]">

      <div class="auth-summer-panel pt-[140px] max-w-[520px] w-full">
        <!--Log in-->
        <div class="auth-summer-card w-full box-border px-[45px] pt-[40px] pb-[44px] m-0 bg-white shadow-xl rounded-[10px]">
          <h6 class="text-[39px] text-center"><img class="w-[41px] h-[41px] max-w-full mr-[15px] inline-block" src="@/assets/logo-square.png"/><span class="text-[#00414a]">{{ $t("reset_password.title") }}</span></h6>
          <p class="text-[14px] p-0 mt-[30px] mx-auto mb-[39px] w-auto max-w-[620px] font-normal leading-[24px] text-center text-[#223265] tracking-normal">{{ $t("reset_password.slogan") }}</p>
          
          <el-form :model="dataForm" :rules="rules" ref="ruleForm" hide-required-asterisk >
              <el-form-item prop="password">
                <label class="w-max leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("reset_password.fields.password") }}</label>
                <el-input type="password" v-model="dataForm.password" clearable show-password :placeholder="$t('reset_password.fields.password_placeholder')" class="h-[25px] text-[16px] border-none font-normal tracking-normal outline-0 !bg-transparent"></el-input>
              </el-form-item>
              <el-form-item prop="confirm_password">
                <label class="w-max leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("reset_password.fields.confirm_password") }}</label>
                <el-input v-model="dataForm.confirm_password" type="password" show-password :placeholder="$t('reset_password.fields.confirm_password_placeholder')"></el-input>
              </el-form-item>
          </el-form>

          <el-button round @click="handleResetPassword('ruleForm')" type="primary" :loading="Loading" class="mt-[25px] text-[16px] w-full cursor-pointer shadow-xl">{{ $t('reset_password.fields.action') }}</el-button>
  
          <p class="text-[14px] font-normal text-[#a7aab0] mt-[24px] text-center align-baseline"><a href="/login" target="_self" class="text-[#3c7fff] underline" @click.prevent="openLogin">{{ $t('reset_password.instructions.login') }}</a></p>
        </div>
      </div>

      <!--left-->
      <div class="pt-[249px] w-[555px] hidden">
        <!--solution-->
        <div class="box-border w-full py-[53px]"> 
          <!--title-->
          <h2 class="mb-[30px] text-[17px] font-bold text-[#080808FF]"><span class="text-[#3C7FFFFF]">{{ $t("reset_password.adv.s1") }}</span> {{ $t("reset_password.adv.s2") }}</h2>
          <!--solution list-->
          <ul class="flex w-full">
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("reset_password.features.f1") }}</span>
              </li>
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("reset_password.features.f2") }}</span>
              </li>
          </ul>
          <!--solution list-->
          <ul class="flex w-full">
            <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("reset_password.features.f3") }}</span>
              </li>
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("reset_password.features.f4") }}</span>
              </li>
          </ul>
        </div>
        <!--follow us-->
        <!-- <div class="follow_us_box">
            <img src="@/assets/index/img/login/proxy_img.webp" alt="">
        </div> -->
      </div> 
      <!-- left end -->

    </div>
  </section>
</template>

<script>
import {resetPassword} from '@/http/api/member'
import md5 from 'js-md5'
import { cookieAuthEnabled } from '@/http/authMode'
export default {
  name: 'resetpassword',
    components:{
    },
  data() {
    return {
      focusIndex: -1,
      
      Loading:false,
      dataForm: {
        password: '',
        confirm_password: '',
      },
      disabled:false,
      disabledStr:'',
    }
  },
  inject: ['updateButtons'],
  computed: {
    rules() {
        const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t("reset_password.message.password_empty")));
        } else {
          if (this.dataForm.confirmPassword !== '') {
            this.$refs.ruleForm.validateField('confirmPassword');
          }
          callback();
        }
      };
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t("reset_password.message.confirm_password_empty")));
        } else if (value !== this.dataForm.password) {
          callback(new Error(this.$t("reset_password.message.password_not_match")));
        } else {
          callback();
        }
      };

      let r = {
        password: [
          {required: true, message: this.$t("reset_password.message.password_empty"), trigger: 'blur'},
          {
            min: 8,
            max: 20,
            message: this.$t("reset_password.message.password_invalid"),
            trigger: 'blur'
          },
          { validator: validatePass, trigger: 'blur' }
        ],
        confirm_password: [
          {required: true, message: this.$t("reset_password.message.confirm_password_empty"), trigger: 'blur'},
          { validator: validatePass2, trigger: 'blur' }
        ],
      };
      return r;
    }    
  },
  mounted() {
    this.updateButtons(false, true);
  },
  methods: {
    openLogin() {
      this.$router.push({path:'/login', query: {redirect: this.$route.query?.redirect ?? ''}})
    },
    handleResetPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          return false;
        }
      });
    },
    save() {
      this.Loading = true;
      resetPassword({
        token: this.$route.query.token,
        password: cookieAuthEnabled ? this.dataForm.password : md5(this.dataForm.password),
      }).then(res=>{
        if(res.code === 1){
          this.Loading = false;
          this.$message.success(this.$t("reset_password.message.success"));
          this.$router.push({path:'/login', query: {redirect: this.$route.query?.redirect ?? ''}})
        }
      }).catch((e)=>{
        this.Loading = false;
        // this.$message.error(e.message ?? e.msg ?? this.$t("reset_password.message.request_fail"));
      })
    },
  }
}
</script>
